import { cycleCountsOverhaulApi } from "./cycleCountsOverhaul";

export const {
  useGetOverhaulIncompleteCycleCountsQuery,
  usePostStartCycleCountingMutation,
  usePostCompleteCountingTaskMutation,
  usePutCycleCountFrequencyMutation
} = cycleCountsOverhaulApi;
